import { BrowserRouter, Route, Routes } from "react-router";
import Form from '../Form';
import Login from '../Login';
import Header from "../Header";
import Find from "../Find";
import Report from '../Report'
import Replace from "../Replace";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Form2 from "../Form/Form2";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ruRU } from "@mui/x-date-pickers/locales";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ru'; // Подключаем русский язык для dayjs

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
      retry: 0,
    }
  }
}
);

const theme = createTheme({}, ruRU);
console.log('!!!locale,', ruRU)
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
          {process.env.NODE_ENV === 'development' && (<ReactQueryDevtools initialIsOpen={false} />)}
          <BrowserRouter>
            <Routes>
              <Route path="/:subpath?" element={<Header />} />
            </Routes>
            <Routes>
              <Route path="/" element={<Form2 />} />
              <Route path="/login" element={<Login />} />
              <Route path="/report" element={<Report />} />
              <Route path="/find" element={<Find />} />
              <Route path="/replace" element={<Replace />} />
              <Route path="/remark" element={<Find />} />
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
